export var timeInForceForOrderType = {
  'Reserve Order': 0,
  'Good till Cancel': 1,
  'Immediate or Cancel': 3,
  'Fill Or Kill': 4
};